module.exports = __webpack_public_path__ + "img/hr-green-asterisk-02.36896582.png";